import { BnbChain, OraiChain } from '@/assets';
import { configs } from '@/configs';

export enum LockOption {
  ThreeMonths = '0',
  SixMonths = '1',
  TwelveMonths = '2',
}

export type EarnValue = {
  apr: number;
  aig: number;
  credit: number;
};

export enum NetworkKey {
  Bsc = 'bsc',
  Oraichain = 'oraichain',
}

export const LOCK_OPTIONS = [
  { value: LockOption.ThreeMonths, label: '3 months' },
  { value: LockOption.SixMonths, label: '6 months' },
  { value: LockOption.TwelveMonths, label: '12 months' },
];

export const NETWORK_OPTIONS = [
  { value: NetworkKey.Bsc, label: 'BNB', icon: BnbChain },
  { value: NetworkKey.Oraichain, label: 'Oraichain', icon: OraiChain },
];

export const APR_PERCENT = {
  [LockOption.ThreeMonths]: 20,
  [LockOption.SixMonths]: 25,
  [LockOption.TwelveMonths]: 30,
};

export const CREDIT_PERCENT = {
  [LockOption.ThreeMonths]: 10,
  [LockOption.SixMonths]: 20,
  [LockOption.TwelveMonths]: 60,
};

export const AIG_PERCENT = {
  [LockOption.ThreeMonths]: 100,
  [LockOption.SixMonths]: 200,
  [LockOption.TwelveMonths]: 300,
};

export const TOKEN_CONTRACT_ADDRESS = {
  [NetworkKey.Bsc]: configs.airiTokenContractBsc,
  [NetworkKey.Oraichain]: configs.airiTokenContract,
};

export const LOCK_CONTRACT_ADDRESS = {
  [NetworkKey.Bsc]: configs.lockContractAddrBsc,
  [NetworkKey.Oraichain]: configs.lockContractAddr,
};
